'use strict'

const SELECTORS = {
    element: '.js-header',
    header: '.js-header',
    menu: '.js-header-menu',
    menuToggle: '.js-menu-toggle',
    menuClose: '.js-menu-close',
    menuBack: '.js-menu-back',
    menuItem: '.js-menu-item',
    menuFirstLevelBtn: '.js-menu-first-level-btn',
    menuSecondLevel: '.js-menu-submenu',
    menuExtraBg: '.js-menu-extra-bg',
    btnBackCart: '.js-header-checkout-back-link'
};

/* =========================
   Utilities (keyboard + focus)
   ========================= */
function getMenu($from) {
    return $($from).closest(SELECTORS.menu);
}

function getFirstLevelBtns($menu) {
    return $menu.find(SELECTORS.menuFirstLevelBtn).filter(':visible:not([disabled])');
}

function getFocusable($menu) {
    return $menu.find('a,button,input,select,textarea,[tabindex]')
        .filter(':visible:not([disabled]):not([tabindex="-1"])');
}

function setRovingTabindex($menu, $active) {
    const $btns = getFirstLevelBtns($menu);
    $btns.attr('tabindex', '-1');
    if ($active && $active.length) {
        $active.attr('tabindex', '0');
    }
}

function moveFocusFirstLevel($current, dir) { // 'next' | 'prev'
    const $menu = getMenu($current);
    const $btns = getFirstLevelBtns($menu);
    if (!$btns.length) return;

    let i = $btns.index($current);
    if (i === -1) {
        setRovingTabindex($menu, $btns.first());
        $btns.first().focus();
        return;
    }

    i = (i + (dir === 'next' ? 1 : -1) + $btns.length) % $btns.length;
    const $next = $btns.eq(i);
    setRovingTabindex($menu, $next);
    $next.focus();
}

// Safe focus helper: focus only if the target exists and is visible enough
function focusSafely($el) {
    if ($el && $el.length) {
        const el = $el.get(0);
        try { el.focus({ preventScroll: true }); } catch (_) { el.focus(); }
    }
}

function openSecondLevelFrom($btn) {
    const $menu = getMenu($btn);
    const $item = $($btn).closest(SELECTORS.menuItem);
    const $submenu = $item.find(SELECTORS.menuSecondLevel).first();
    if (!$submenu.length) return;

    $menu.addClass('cc-menu--second-level-open');

    // close all other second-level menus
    $menu.find(SELECTORS.menuFirstLevelBtn).not($btn).attr('aria-expanded', 'false');
    $menu.find(SELECTORS.menuSecondLevel).attr('aria-hidden', 'true').removeClass('cc-open');

    // hover parity for keyboard: highlight current first-level button
    $menu.find(SELECTORS.menuFirstLevelBtn).removeClass('cc-hover');
    $($btn).addClass('cc-hover');

    // open the selected one
    $($btn).attr('aria-expanded', 'true');
    $submenu.attr('aria-hidden', 'false').addClass('cc-open');

    // focus on the first interactive element inside the second-level menu
    const $f = $submenu.find('a,button,input,select,textarea,[tabindex]')
        .filter(':visible:not([disabled]):not([tabindex="-1"])')
        .first();
    if ($f.length) {
        $f.focus();
    }
}

function closeSecondLevelIn($menu, focusBack, $from) {
    $menu.removeClass('cc-menu--second-level-open');
    $menu.find(SELECTORS.menuFirstLevelBtn).attr('aria-expanded', 'false');
    $menu.find(SELECTORS.menuSecondLevel).attr('aria-hidden', 'true').removeClass('cc-open');

    // remove keyboard "hover" highlight when closing second level
    $menu.find(SELECTORS.menuFirstLevelBtn).removeClass('cc-hover');

    // inside closeSecondLevelIn($menu, focusBack, $from)
    if (focusBack) {
        let $btn = $($from)
            .closest(SELECTORS.menuItem)
            .find(SELECTORS.menuFirstLevelBtn)
            .filter(':visible')
            .first();

        if (!$btn.length) $btn = getFirstLevelBtns($menu).first(); // already :visible
        if (!$btn.length) $btn = $(SELECTORS.menuToggle);

        setRovingTabindex($menu, $btn);
        focusSafely($btn);
    }
}


/* =========================
   Open / Close menu
   ========================= */
function openMenu() {
    $(SELECTORS.header).addClass('cc-header--menu-open');
    $(SELECTORS.menuToggle).attr('aria-expanded', 'true');
    $(SELECTORS.menu).attr('aria-hidden', 'false');
    $('body').addClass('cc-body-no-scroll cc-menu-is-open');

    // initialize roving tabindex on first-level buttons
    requestAnimationFrame(() => {
        const $menu = $(SELECTORS.menu);
        const $first = getFirstLevelBtns($menu).first();
        if ($first.length) setRovingTabindex($menu, $first);
    });

    // focus on the first first-level button (timing consistent with your style)
    setTimeout(() => {
        $(SELECTORS.menu).find(SELECTORS.menuFirstLevelBtn).first().focus();
    }, 200);
}

function closeMenu() {
    // Update toggle state first
    $(SELECTORS.menuToggle).attr('aria-expanded', 'false');

    // Move focus OUT of the menu BEFORE hiding it (prevents aria-hidden warning)
    requestAnimationFrame(() => {
        const el = $(SELECTORS.menuToggle).get(0);
        if (el && el.focus) {
            try { el.focus({ preventScroll: true }); } catch (_) { el.focus(); }
        }

        // Now it's safe to hide the menu and remove classes
        requestAnimationFrame(() => {
            $(SELECTORS.header).removeClass('cc-header--menu-open');
            $(SELECTORS.menu).attr('aria-hidden', 'true');
            $('body').removeClass('cc-body-no-scroll cc-menu-is-open');
        });
    });
}


/* =========================
   Document Ready
   ========================= */
$(() => {
    let lastScroll = 0;

    $('.cc-header-checkout__steps-wrp .cc-header-checkout__step.cc-active')
        .attr('aria-current', 'step');

    $(window).on('scroll', function() {
        let currentScroll = $(window).scrollTop();

        // Sticky header after 200px scroll
        if (currentScroll > 200) {
            $(SELECTORS.header).addClass('cc-header--sticky');
        } else {
            $(SELECTORS.header).removeClass('cc-header--sticky');
        }

        // Hide / show header on scroll direction (mobile)
        if (currentScroll >= lastScroll) {
            $(SELECTORS.header).removeClass('cc-header--sticky-top').addClass('cc-header--sticky-bottom');
        } else {
            $(SELECTORS.header).removeClass('cc-header--sticky-bottom').addClass('cc-header--sticky-top');
        }
        lastScroll = currentScroll;
    });

    $(document).on('click', SELECTORS.menuToggle, function(e) {
        e.preventDefault();
        if ($(SELECTORS.header).hasClass('cc-header--menu-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    $(document).on('click', SELECTORS.btnBackCart, function(e) {        
        var isCheckoutStage = $('.js-checkout-main').data('checkout-stage') != undefined;
        var isLoginStage = window.location.pathname.toLocaleLowerCase().indexOf('login') > -1;
        
        if (isLoginStage) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = $(this).data('carturl');
        } else if (!isCheckoutStage) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = $(this).data('homeurl');
        }
    });

    $(document).on('click', SELECTORS.menuClose + ', ' + SELECTORS.menuExtraBg, function(e) {
        e.preventDefault();
        closeMenu();
    });

    $(document).on('click', SELECTORS.menuFirstLevelBtn, function(e) {
        if ($(this).hasClass('js-menu-first-level-btn--link')) return;
        
        e.preventDefault();

        const $menu = $(this).closest(SELECTORS.menu);
        const $submenu = $(this).closest(SELECTORS.menuItem).find(SELECTORS.menuSecondLevel);

        if (window.isDesktop) {
            const url = $(this).data('url');
            if (url) {
                window.location.href = url;
                return;
            }
        }

        // close siblings (state + ARIA)
        $menu.find(SELECTORS.menuFirstLevelBtn).not(this).attr('aria-expanded', 'false').removeClass('cc-hover');
        $menu.find(SELECTORS.menuSecondLevel).attr('aria-hidden', 'true').removeClass('cc-open');

        // open current
        $menu.addClass('cc-menu--second-level-open');
        $(this).attr('aria-expanded', 'true').addClass('cc-hover');
        $submenu.attr('aria-hidden', 'false').addClass('cc-open');
    });

    $(document).on('click', SELECTORS.menuBack, function(e) {
        e.preventDefault();

        const $menu = $(this).closest(SELECTORS.menu);
        const $item = $(this).closest(SELECTORS.menuItem);

        // close current second level (state + ARIA)
        $menu.removeClass('cc-menu--second-level-open');
        $item.find(SELECTORS.menuFirstLevelBtn).attr('aria-expanded', 'false');
        $item.find(SELECTORS.menuSecondLevel).attr('aria-hidden', 'true').removeClass('cc-open');

        // restore focus to a visible first-level trigger (or fallback) on next frame
        requestAnimationFrame(() => {
            // 1) parent first-level button if visible
            let $target = $item.find(SELECTORS.menuFirstLevelBtn).filter(':visible').first();

            // 2) otherwise first visible first-level button in the same menu
            if (!$target.length) $target = $menu.find(SELECTORS.menuFirstLevelBtn).filter(':visible').first();

            // 3) ultimate fallback: the menu toggle
            if (!$target.length) $target = $(SELECTORS.menuToggle);

            focusSafely($target);
        });
    });


    // Hover (desktop only)
    if (window.isDesktop) {
        $(document).on('mouseenter', SELECTORS.menuFirstLevelBtn, function() {
            const $menu = $(this).closest(SELECTORS.menu);
            $menu.find(SELECTORS.menuFirstLevelBtn).removeClass('cc-hover').attr('aria-expanded', 'false');
            $menu.find(SELECTORS.menuSecondLevel).attr('aria-hidden', 'true').removeClass('cc-open');

            if ($(this).hasClass('js-menu-first-level-btn--link')) return;
            $menu.addClass('cc-menu--second-level-open');
            $(this).addClass('cc-hover').attr('aria-expanded', 'true');
            $(this).closest(SELECTORS.menuItem).find(SELECTORS.menuSecondLevel).attr('aria-hidden', 'false').addClass('cc-open');
        });

        $(document).on('mouseleave', SELECTORS.menu, function() {
            const $menu = $(this);
            $menu.removeClass('cc-menu--second-level-open');
            $menu.find(SELECTORS.menuFirstLevelBtn).removeClass('cc-hover').attr('aria-expanded', 'false');
            $menu.find(SELECTORS.menuSecondLevel).attr('aria-hidden', 'true').removeClass('cc-open');
        });
    }

    /* =========================================
       Keyboard Navigation:
       Esc behavior, ↑/↓/→/← (desktop only),
       and Focus Trap when menu is open
       ========================================= */
    $(document).on('keydown', SELECTORS.header, function(e) {
        const isOpen = $(SELECTORS.header).hasClass('cc-header--menu-open');
        if (!isOpen) return;

        const key = e.key;
        const $menu = $(SELECTORS.menu);
        const $t = $(e.target);

        // Focus Trap (Tab / Shift+Tab)
        if (key === 'Tab') {
            const $active = $(document.activeElement);
            const $openSubmenu = $active.closest(SELECTORS.menuSecondLevel).filter('.cc-open');

            if ($openSubmenu.length) {
                // --- Local trap inside the currently open second-level submenu ---
                const $local = $openSubmenu.find('a,button,input,select,textarea,[tabindex]')
                    .filter(':visible:not([disabled]):not([tabindex="-1"])');
                if (!$local.length) return; // nothing to trap locally

                const first = $local.first().get(0);
                const last  = $local.last().get(0);

                // wrap inside submenu
                if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                    return;
                }
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                    return;
                }

                // otherwise let Tab move naturally within the submenu
                return;
            }

            // --- Global trap inside the whole menu (when not inside a second-level submenu) ---
            // Make top-level items tabbable so Tab can pass through them in DOM order
            getFirstLevelBtns($(SELECTORS.menu)).attr('tabindex', '0');

            const $f = getFocusable($(SELECTORS.menu)); // all focusables inside the menu
            if (!$f.length) return;

            const first = $f.first().get(0);
            const last  = $f.last().get(0);

            // wrap at menu boundaries
            if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
                return;
            }
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
                return;
            }

            // otherwise let Tab move naturally within the menu
            return;
        }


        // Esc: close only the second level if open, otherwise close the menu
        if (key === 'Escape') {
            if ($menu.hasClass('cc-menu--second-level-open')) {
                e.preventDefault();
                closeSecondLevelIn($menu, true, e.target);
            } else {
                e.preventDefault();
                closeMenu();
            }
            return;
        }

        // Keyboard arrows - desktop only
        if (!window.isDesktop) return;

        // ↑ / ↓ navigation between first-level buttons
        if ($t.is(SELECTORS.menuFirstLevelBtn) && (key === 'ArrowDown' || key === 'ArrowUp')) {
            e.preventDefault();
            moveFocusFirstLevel($t, key === 'ArrowDown' ? 'next' : 'prev');
            return;
        }

        // → on first-level button: open submenu and focus first element inside
        if ($t.is(SELECTORS.menuFirstLevelBtn) && key === 'ArrowRight') {
            e.preventDefault();
            openSecondLevelFrom($t);
            return;
        }

        // Enter/Space on first-level button: open second level and add cc-hover (keyboard parity with hover/click)
        if ($t.is(SELECTORS.menuFirstLevelBtn) && (key === 'Enter' || key === ' ' || key === 'Spacebar')) {
            e.preventDefault();
            openSecondLevelFrom($t);
            return;
        }

        // ← inside a second-level menu: close it and move focus back to parent
        if (key === 'ArrowLeft' && $t.closest(SELECTORS.menuSecondLevel).length) {
            e.preventDefault();
            closeSecondLevelIn($menu, true, e.target);
            return;
        }
    });
});
